/**
 * Update Swiper in a given section to 2 slides per row
 * @param {string} sectionId - The ID of the section containing the Swiper
 * @param {number} slidesPerView - Number of slides per row (default 2)
 * @param {number} spaceBetween - Space between slides (default 20)
 */
function updateSwiperSlides(sectionId = 'custom_product_highlights', slidesPerView = 2, spaceBetween = 7) {
  const interval = setInterval(() => {
    const swiperEl = document.querySelector(`#${sectionId} .swiper`);
    if (swiperEl && swiperEl.swiper) {
      const swiperInstance = swiperEl.swiper;

      // Update Swiper settings
      swiperInstance.params.slidesPerView = slidesPerView;
      swiperInstance.params.spaceBetween = spaceBetween;
      swiperInstance.update();

      // Stop the interval once done
      clearInterval(interval);
      console.log(`Swiper in #${sectionId} updated to ${slidesPerView} slides per row!`);
    }
  }, 500); // check every 500ms
}

function initCustomFancyBox() {
  Fancybox.bind("[data-fancybox]", {
    Carousel: {
      Toolbar: {
        display: {
          left: ["counter"],
          right: ["close"],
        },
      },
      Zoomable: {
        Panzoom: {
          maxScale: "cover",
          panMode: "mousemove",
          mouseMoveFactor: 1.1,
        },
      },
    },
  });
}

function initThemeFeatures(scope = document) {
  if (scope === document) {
    initCustomFancyBox();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initThemeFeatures();
});

document.addEventListener('shopify:section:load', (event) => {
  initThemeFeatures(event.target);
});
